// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U0_CL","title":"styles_title__RihyW"};